module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('UserButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('status', {
    attrs: {
      "status": _vm.item.enabled ? 'ACTIVE' : 'PENDING_REVIEW'
    }
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v("U" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.username))])], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Federation")]), (_vm.item.federation !== null) ? _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.federation.name))]) : _vm._e()]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Email")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.email))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Role")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.roles.map(function (u) { return u.name; }).join(', ')))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.created_at))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'user',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0d6087c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/User.vue
// module id = 2537
// module chunks = 1